export default {
  "debug": false
}